<template>
  <scoped>
    <div>
      <span
        v-for="link in links"
        :key="link.title"
        @click="routeRedirect(link.routeName)"
      >
        {{ link.title ? link.title : link.routeName }}
        /
      </span>
      <span>
        {{ title }}
      </span>
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import router from "@/router"
  import {onBeforeMount} from "vue"

  const links = defineModel("links", {
    default: [],
    required: false,
    type: Array<{
      title: string,
      routeName: string
    }>
  })

  const title = defineModel("title", {
    default: null,
    required: false,
    type: String
  })

  onBeforeMount(() => {
    setCurrentRouteTitle()
  })
  
  function setCurrentRouteTitle() {
    if (title.value != null) {
      return
    }
    try {
      title.value = router.currentRoute.value.meta.title.toString()
    } catch (error) {
      console.error(error)
    }
  }
  
  function routeRedirect(routeName: string) {
    router.push({
      name: routeName
    })
  }
</script>

<style scoped>
  div {
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    padding: 10px;
  
    > span {
      font-size: 1.25em;
  
      &:hover {
        color: var(--theme-color-primary);
        cursor: pointer;
      }
  
      &:last-child {
        color: var(--theme-color-primary);
  
        &:hover {
          cursor: auto;
          text-decoration: none;
        }
      }
    }
  }
</style>
